import { Actions, UseAssignmentState } from './types';

export const defaultState = (): UseAssignmentState => ({
  assignments: [],
  allGroups: [],
  selectedGroups: [],
  hasUnsavedChanges: false,
  selectedStudents: [],
  saveSuccessful: false,
  letter: '',
  groupFilter: 'All',
});

export const reducers = (state: UseAssignmentState, action: Actions): UseAssignmentState => {
  switch (action.type) {
    case 'SET_LETTER':
      return { ...state, letter: action.payload.letter };
    case 'SET_UNSAVED_CHANGES':
      return { ...state, hasUnsavedChanges: action.payload.hasUnsavedChanges };
    case 'SET_GROUP_FILTER':
      return { ...state, groupFilter: action.payload.groupFilter };
    case 'SET_SAVE_SUCCESS':
      return { ...state, ...action.payload };
    case 'SET_ASSIGNMENTS':
      return { ...state, assignments: action.payload.assignments };
    case 'SET_ALL_GROUPS':
      return { ...state, allGroups: action.payload.groups };
    case 'SET_SELECTED_GROUPS_AND_STUDENTS':
      return { ...state, ...action.payload };
  }
};
